import { Button, Paper, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

/** Raises a no-op TEST approval (backend REGISTRY_TEST_APPROVALS=true only) to try the inbox. */
export default function TestRequestForm({
  onRaise,
}: {
  onRaise: (title: string, amount?: string) => Promise<boolean>;
}) {
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    const ok = await onRaise(title.trim(), amount.trim() || undefined);
    setBusy(false);
    if (ok) {
      setTitle('');
      setAmount('');
    }
  };
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Raise a test request
      </Typography>
      <Stack
        component="form"
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        onSubmit={(event) => {
          event.preventDefault();
          void submit();
        }}
      >
        <TextField
          size="small"
          label="Title"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          sx={{ flex: 1 }}
        />
        <TextField
          size="small"
          label="Amount (optional)"
          value={amount}
          onChange={(event) => setAmount(event.target.value)}
          inputProps={{ inputMode: 'decimal' }}
          sx={{ width: { sm: 180 } }}
        />
        <Button type="submit" variant="outlined" disabled={busy || !title.trim()}>
          Raise test request
        </Button>
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        Test requests change nothing when decided. Another person must approve one you raise.
      </Typography>
    </Paper>
  );
}
